import {
    CloseOutlined,
    CheckOutlined,
    ExclamationCircleOutlined,
} from "@ant-design/icons";
import { Button, Col, Image, Modal, Tag, Spin, Input, Form } from "antd";
import { useEffect, useState } from "react";
import { authApis } from "../../services/authApi";
import Paginate from "./../../commons/Paginate";
import MainLayout from "./../../components/mainLayout";
import "./index.scss";
import { ROOT_URL } from "./../../constants/api";
import { Link } from "react-router-dom";
import { nofication } from "./../../commons/Nofication";
import moment from "moment";
const { TextArea } = Input;

const Register = () => {
    const [newsList, setNewsList] = useState([]);
    const [totalItem, setTotalItem] = useState(0);
    const [paginateCurrent, setPaginateCurrent] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [searchValue, setSearchValue] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [value, setValue] = useState("");

    useEffect(() => {
        fetchData();
    }, [paginateCurrent, perPage, searchValue]);

    const fetchData = () => {
        const urlParams = `page=${paginateCurrent}&perPage=${perPage}&search=${searchValue}`;
        authApis
            .getLang(urlParams)
            .then((data) => {
                const newData = data.lang.data.map((item, index) => {
                    return { ...item, isOpenEn: false, isOpenVi: false, isOpenKr: false, isOpenCn: false, isOpenJp: false };
                });
                console.log('newData', newData);
                setNewsList(newData ?? []);
                setTotalItem(data.lang.total ?? 0);
                setIsLoading(false);
            })
            .catch((errors) => {
                nofication("error", "Thất bại", "Lấy dữ liệu thất bại");
            });
    };

    const onDelete = (id) => {
        authApis
            .deleteNews(id)
            .then((data) => {
                nofication("success", "Thành công!", "Xóa dữ liệu thành công!");
                fetchData();
            })
            .catch((errors) => {
                nofication("error", "Thất bại", "Lấy dữ liệu thất bại");
            });
    };

    const onConfirmDelete = (id) => {
        Modal.confirm({
            title: "Confirm",
            icon: <ExclamationCircleOutlined />,
            content: "Bạn có muốn xóa?",
            okText: "Ok",
            cancelText: "Cancel",
            onOk: () => {
                onDelete(id);
            },
            onCancel() {
                return;
            },
        });
    };

    const showView = (id, title, lang) => {
        const objIndex = newsList.findIndex(item => item.id === id);
        newsList[objIndex][lang] = true;
        setNewsList([...newsList]);
        setValue(title);

        const newData = newsList.map((item, index) => {
            if (item.id !== id) {
                return { ...item, isOpenEn: false, isOpenVi: false, isOpenKr: false, isOpenCn: false, isOpenJp: false };
            } else {
                return { ...item, isOpenEn: false, isOpenVi: false, isOpenKr: false, isOpenCn: false, isOpenJp: false, [lang]: true };
            }
        });
        setNewsList([...newData]);
    };

    const closeView = (id, title) => {
        const objIndex = newsList.findIndex(item => item.id === id);
        newsList[objIndex][title] = false;
        setNewsList([...newsList]);
    };

    const changeValue = (e) => {
        setValue(e.target.value);
    };

    const onSubmit = (id, title, lang) => {
        const formData = new FormData();
        formData.append('content', value);
        formData.append('id', id);
        formData.append('lang', lang);
        authApis
            .updateLang(formData)
            .then((data) => {
                nofication("success", "Thành công!", "Cập nhật dữ liệu thành công!");
                fetchData();
            })
            .catch((errors) => {
                nofication("error", "Thất bại", "Cập nhật dữ liệu thất bại");
            });
    };

    return (
        <MainLayout
            isShowActionHeader={true}
            title="Translate"
            link="/translate/"
            titleNew="Translate / List"
            isTranslate={true}
            isHiddenAction={true}
            setSearchValue={setSearchValue}
        >
            <Spin spinning={isLoading}>
                <Col span={24} className='main-min-height-table cna2'>
                    <div
                        style={{
                            width: "100%",
                            margin: "20px 10px 0px 0px",
                            padding: "20px",
                            borderTopRightRadius: "10px",
                            borderTopLeftRadius: "10px",
                            background: "white",
                        }}
                        className='table'
                    >
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th scope="col" style={{ width: '20%' }}>Key</th>
                                    <th scope="col" style={{ width: '16%' }}>En</th>
                                    <th scope="col" style={{ width: '16%' }}>Vi</th>
                                    <th scope="col" style={{ width: '16%' }}>Kr</th>
                                    <th scope="col" style={{ width: '16%' }}>Jp</th>
                                    <th scope="col" style={{ width: '16%' }}>Cn</th>
                                </tr>
                            </thead>
                            <tbody>
                                {newsList.length ? (
                                    newsList.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <th scope="row">
                                                    {item.key}
                                                </th>
                                                <th scope="row">
                                                    {
                                                        item.isOpenEn === false ?
                                                            <p onClick={() => showView(item.id, item.en, 'isOpenEn')}>{item.en}</p>
                                                            :
                                                            <div className="wrapper-input">
                                                                <Form.Item className="proas">
                                                                    <TextArea autoSize={{ minRows: 10, maxRows: 10 }} value={value} onChange={changeValue} />
                                                                    <Button type="primary" icon={<CheckOutlined />} className='btn-1' onClick={() => onSubmit(item.id, item.title, 'en')} />
                                                                    <Button icon={<CloseOutlined />} className='btn-2' onClick={() => closeView(item.id, 'isOpenEn')}/>
                                                                </Form.Item>
                                                            </div>
                                                    }
                                                </th>
                                                <th scope="row">
                                                    {
                                                        item.isOpenVi === false ?
                                                            <p onClick={() => showView(item.id, item.vi, 'isOpenVi')}>{item.vi}</p>
                                                            :
                                                            <div className="wrapper-input">
                                                                <Form.Item className="proas">
                                                                    <TextArea autoSize={{ minRows: 10, maxRows: 10 }} value={value} onChange={changeValue} />
                                                                    <Button type="primary" icon={<CheckOutlined />} className='btn-1' onClick={() => onSubmit(item.id, item.title, 'vi')} />
                                                                    <Button icon={<CloseOutlined />} className='btn-2' onClick={() => closeView(item.id, 'isOpenVi')} />
                                                                </Form.Item>
                                                            </div>
                                                    }
                                                </th>
                                                <th scope="row">
                                                    {
                                                        item.isOpenKr === false ?
                                                            <p onClick={() => showView(item.id, item.kr, 'isOpenKr')}>{item.kr}</p>
                                                            :
                                                            <div className="wrapper-input">
                                                                <Form.Item className="proas">
                                                                    <TextArea autoSize={{ minRows: 10, maxRows: 10 }} value={value} onChange={changeValue} />
                                                                    <Button type="primary" icon={<CheckOutlined />} className='btn-1' onClick={() => onSubmit(item.id, item.title, 'kr')} />
                                                                    <Button icon={<CloseOutlined />} className='btn-2' onClick={() => closeView(item.id, 'isOpenKr')}/>
                                                                </Form.Item>
                                                            </div>
                                                    }
                                                </th>
                                                <th scope="row">
                                                    {
                                                        item.isOpenCn === false ?
                                                            <p onClick={() => showView(item.id, item.cn, 'isOpenCn')}>{item.cn}</p>
                                                            :
                                                            <div className="wrapper-input">
                                                                <Form.Item className="proas">
                                                                    <TextArea autoSize={{ minRows: 10, maxRows: 10 }} value={value} onChange={changeValue} />
                                                                    <Button type="primary" icon={<CheckOutlined />} className='btn-1' onClick={() => onSubmit(item.id, item.title, 'cn')} />
                                                                    <Button icon={<CloseOutlined />} className='btn-2' onClick={() => closeView(item.id, 'isOpenCn')}/>
                                                                </Form.Item>
                                                            </div>
                                                    }
                                                </th>
                                                <th scope="row">
                                                    {
                                                        item.isOpenJp === false ?
                                                            <p onClick={() => showView(item.id, item.jp, 'isOpenJp')}>{item.jp}</p>
                                                            :
                                                            <div className="wrapper-input">
                                                                <Form.Item className="proas">
                                                                    <TextArea autoSize={{ minRows: 10, maxRows: 10 }} value={value} onChange={changeValue} />
                                                                    <Button type="primary" icon={<CheckOutlined />} className='btn-1' onClick={() => onSubmit(item.id, item.title, 'jp')} />
                                                                    <Button icon={<CloseOutlined />} className='btn-2' onClick={() => closeView(item.id, 'isOpenJp')}/>
                                                                </Form.Item>
                                                            </div>
                                                    }
                                                </th>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        {isLoading === false ? (
                                            <td colspan="9">
                                                <h4
                                                    style={{
                                                        textAlign: "center",
                                                        margin: "20px 0px",
                                                    }}
                                                >
                                                    (No data)
                                                </h4>
                                            </td>
                                        ) : (
                                            <></>
                                        )}
                                    </tr>
                                )}
                            </tbody>
                        </table>

                    </div>
                    <div style={{
                        width: "100%",
                        padding: "20px",
                        background: "white",
                        borderBottomRightRadius: "10px",
                        borderBottomLeftRadius: "10px",
                    }}>
                        <Paginate
                            setPaginateCurrent={setPaginateCurrent}
                            setPerPage={setPerPage}
                            totalItem={totalItem}
                            currentPage={paginateCurrent}
                        />
                    </div>
                </Col>
            </Spin>
        </MainLayout>
    );
};

export default Register;
